(() => {
  const adultOrder = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL', '6XL', '7XL', '8XL', '9XL', '10XL'];
  const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
  function initialise(root = document) {
    root.querySelectorAll('.rnr-option').forEach(option => {
      if (option.dataset.rnrReady) return;
      option.dataset.rnrReady = 'true';
      const values = option.querySelector('.rnr-option-values');
      const items = [...values.children];
      if (option.dataset.optionName === 'size') {
        const kids = items.filter(item => /^kids?\s/i.test(item.dataset.optionValue));
        const adults = items.filter(item => !kids.includes(item));
        adults.sort((a, b) => {
          const ai = adultOrder.indexOf(a.dataset.optionValue.toUpperCase());
          const bi = adultOrder.indexOf(b.dataset.optionValue.toUpperCase());
          if (ai >= 0 && bi >= 0) return ai - bi;
          if (ai >= 0) return -1;
          if (bi >= 0) return 1;
          return collator.compare(a.dataset.optionValue, b.dataset.optionValue);
        });
        kids.sort((a, b) => collator.compare(a.dataset.optionValue, b.dataset.optionValue));
        const addGroup = (group, label) => {
          if (!group.length) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'rnr-size-group';
          if (kids.length && adults.length) {
            const heading = document.createElement('p');
            heading.className = 'rnr-size-heading';
            heading.textContent = label;
            wrapper.append(heading);
          }
          group.forEach(item => wrapper.append(item));
          values.append(wrapper);
        };
        addGroup(adults, option.dataset.adultsLabel);
        addGroup(kids, option.dataset.kidsLabel);
      }
      option.querySelectorAll('.swatches__form--label').forEach(label => {
        label.addEventListener('keydown', event => {
          if (event.key === ' ') {
            event.preventDefault();
            label.click();
          }
        });
      });
      const updateAvailability = () => {
        option.querySelectorAll('.js-swatch-element').forEach(item => {
          const label = item.querySelector('label');
          const name = item.dataset.optionValue;
          const description = item.classList.contains('soldout') ? name + ' — ' + option.dataset.soldOutLabel : name;
          label.setAttribute('aria-label', description);
          label.title = description;
        });
      };
      updateAvailability();
      new MutationObserver(updateAvailability).observe(values, {attributes: true, attributeFilter: ['class'], subtree: true});
    });
    root.querySelectorAll('.rnr-shopping-nav').forEach(nav => {
      if (nav.dataset.rnrReady) return;
      nav.dataset.rnrReady = 'true';
      const categories = [...nav.querySelectorAll('.rnr-category')];
      categories.forEach(category => {
        category.addEventListener('toggle', () => {
          if (category.open) categories.forEach(other => {if (other !== category) other.open = false;});
        });
      });
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = categories.find(category => category.open);
        if (open) {
          open.open = false;
          open.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', event => {
        if (!nav.contains(event.target)) categories.forEach(category => {category.open = false;});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
